/**
 * The four steps a new customer goes through, as a row of numbered circles joined by a line.
 *
 * Short labels on purpose. The onboarding rail (onboarding/flow.ts RAIL) names steps by what has
 * happened -- "Account created" -- which is true on the screens after sign-in and false on the sign-in
 * screen itself. These name what each step IS, so they are true wherever the person is standing.
 *
 * An ordered list with aria-current="step", so the position is carried by the markup and not only by
 * colour, and completed steps carry a check mark and a spoken "completed". Presentation only: it holds
 * no state and decides nothing about where the person is; the caller passes the index.
 */
export const FLOW_STEPS = ['Account', 'Connect', 'Assessment', 'Dashboard'] as const

export function FlowStepper({ at }: { at: number }) {
  return (
    <nav className="flow-stepper" aria-label="Setup progress">
      <ol>
        {FLOW_STEPS.map((label, index) => {
          const done = index < at
          const current = index === at
          return (
            <li
              key={label}
              className={current ? 'flow-step is-current' : done ? 'flow-step is-done' : 'flow-step'}
              aria-current={current ? 'step' : undefined}
            >
              <span className="flow-mark" aria-hidden="true">
                {done ? '✓' : String(index + 1)}
              </span>
              <span className="flow-label">{label}</span>
              {done ? <span className="sr-only">completed</span> : null}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
